import type { ICustomControlRequestReadProps } from '../../../interfaces/customControlRequestReadProps';
import { getServiceLabel } from '../../../../../../../common/customControls/getServiceLabel';
import { getDisplayName } from '../../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../../translate';
import { ContactReadButtons } from '../../../../../elements/carePathButtons/ContactReadButtons';
import { UserTextParagraph } from '../../../../../elements/common';
import { FormLabel } from '../../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../../elements/forms/InputContainer';
import { ProcessContainer } from '../../../../episodes/common';
import { ProcessItemHeader } from '../../../../episodes/ProcessItemHeader';
import { RequestThumbnails } from '../../../utils/v1/RequestThumbnails';

export function PilotContactV1RequestRead(props: ICustomControlRequestReadProps) {
    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.process.dateSent || (props.request && props.request.dateSent)}
                isFirstItem={props.isFirstItem}
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => {
                    await props.updateItemState({ ...props.itemState, isOpen: isOpened });
                }}
                organizationName={props.process.requesterOrganization?.name}
                practitionerName={
                    props.process.requesterPractitioner
                        ? getDisplayName(props.process.requesterPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                title={getServiceLabel(props.process.code, 'request', props.process.name)}
            />

            {props.request.customControlData.anamnese && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('carePlan.anamnese')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.anamnese}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.request.customControlData.onderzoek && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('procedure.procedure')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.onderzoek}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.request.customControlData.diagnose && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosis.diagnosis')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.diagnose}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.request.customControlData.beleid && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('diagnosticReport.policy')}</FormLabel>
                    <InputContainer>
                        <UserTextParagraph>{props.request.customControlData.beleid}</UserTextParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            <RequestThumbnails {...props} />

            <ContactReadButtons {...props} />
        </ProcessContainer>
    );
}
